const sliderContent = {
  list: [
    {
      label: '1. Baixe o app do FGTS',
      header: {
        alt: 'Imagem da tela inicial do app FGTS',
        filename: 'fgts-slider-1'
      },
      cardText:
        'Utilize sua senha para entrar ou cadastre uma senha no primeiro acesso'
    },
    {
      label: '2. Altere a forma de saque do FGTS',
      header: {
        alt: 'Imagem da tela do app FGTS com foco na opção: Sistemática de saque do seu FGTS',
        filename: 'fgts-slider-2'
      },
      cardText:
        'Na página inicial, clique em <strong>Sistemática de saque do seu FGTS?</strong>. Leia e aceite os termos e condições e clique em <strong>Optar pelo Saque-Aniversário</strong>'
    },
    {
      label: '3. Autorize a consulta às suas informações',
      header: {
        alt: 'Imagem da tela do app FGTS com foco na opção com título Autorização de consulta às informações do FGTS e subtítulo Autorize bancos a consultar suas informações.',
        filename: 'fgts-slider-3'
      },
      cardText:
        'Acesse o menu <strong>Mais</strong> da página inicial e clique em <strong>Autorização de consulta às informações do FGTS</strong> e, depois, em <strong>Empréstimo Saque-Aniversário</strong>'
    },
    {
      label: '4. Compartilhe suas informações',
      header: {
        alt: 'Imagem da tela do app FGTS com foco na opção Banco Itau Consignado S.A.',
        filename: 'fgts-slider-4'
      },
      cardText:
        'Busque por <strong>Banco Itaú Consignado S.A.</strong> no campo de pesquisa e confirme a autorização de consulta ao seu saldo FGTS.<br/><strong>Pronto! Agora você pode voltar no site do Itaú e continuar a simulação</strong>'
    }
  ],
  title: 'Como aderir ao saque aniversário'
}

export default sliderContent
